export type PossibleTypesResultData = {
  possibleTypes: {
    Account: [
      "AirwallexExternalAccountDetails",
      "AkahuExternalAccountDetails",
      "BeneficiaryAccount",
      "BrexExternalAccountDetails",
      "ExternalBankAccountAsset",
      "FXAsset",
      "FixedIncomeFundAsset",
      "JpmcExternalAccountDetails",
      "MercuryExternalAccountDetails",
      "NoticeAccountAsset",
      "PlaidExternalAccountDetails",
      "QuilttExternalAccountDetails",
      "RampExternalAccountDetails",
      "SaltEdgeExternalAccountDetails",
      "SavingsAsset",
      "SissExternalAccountDetails",
      "SkriptExternalAccountDetails",
      "StripeExternalAccountDetails",
      "TermDepositAsset",
    ];
    AccountOnboardingRequest: [
      "FXOnboardingRequest",
      "ProductAccountOnboardingRequest",
    ];
    AccountsSummaryGroup: [
      "AccountTypeAccountsSummaryGroup",
      "AssetClassAccountsSummaryGroup",
      "BusinessEntityAccountsSummaryGroup",
      "CurrencyAccountsSummaryGroup",
      "ProviderAccountsSummaryGroup",
    ];
    ApprovalTarget: ["Payout", "Transfer", "TransferGroup"];
    Asset: [
      "ExternalBankAccountAsset",
      "FXAsset",
      "FixedIncomeFundAsset",
      "NoticeAccountAsset",
      "SavingsAsset",
      "TermDepositAsset",
    ];
    AssetRule: [
      "AlertAssetRule",
      "RecurringTransferAssetRule",
      "RecurringWithdrawalAssetRule",
      "SweepAssetRule",
      "TopUpAssetRule",
    ];
    BatchUpdateAssetResult: [
      "BatchUpdateAssetErrorResult",
      "BatchUpdateAssetSuccessResult",
    ];
    EburyTradeDetails: [
      "EburyDrawdownDetails",
      "EburyFixedForwardDetails",
      "EburyNDFDetails",
      "EburySpotTradeDetails",
      "EburyWindowForwardDetails",
    ];
    EventActor: [
      "EventActorExternalSystem",
      "EventActorExternalUser",
      "EventActorInternalUser",
      "EventActorScheduledJob",
      "EventActorStandaloneJob",
    ];
    ExternalAccountDetails: [
      "AirwallexExternalAccountDetails",
      "AkahuExternalAccountDetails",
      "BrexExternalAccountDetails",
      "JpmcExternalAccountDetails",
      "MercuryExternalAccountDetails",
      "PlaidExternalAccountDetails",
      "QuilttExternalAccountDetails",
      "RampExternalAccountDetails",
      "SaltEdgeExternalAccountDetails",
      "SissExternalAccountDetails",
      "SkriptExternalAccountDetails",
      "StripeExternalAccountDetails",
    ];
    ExternalBankAccountDataInstitution: [
      "AkahuExternalBankAccountDataInstitution",
      "BrexExternalBankAccountDataInstitution",
      "JpmcExternalBankAccountDataInstitution",
      "MercuryExternalBankAccountDataInstitution",
      "PlaidExternalBankAccountDataInstitution",
      "QuilttExternalBankAccountDataInstitution",
      "RampExternalBankAccountDataInstitution",
      "SaltEdgeExternalBankAccountDataInstitution",
      "SissExternalBankAccountDataInstitution",
      "SkriptExternalBankAccountDataInstitution",
      "StripeExternalBankAccountDataInstitution",
    ];
    FXHedge: ["ExternalFXHedge", "ManagedFXHedge"];
    FXProvider: ["CurrencycloudAccount", "EburyClient"];
    FXRateDataPoint: ["FXRateDataPointDate", "FXRateDataPointDateTime"];
    FXTrade: ["CurrencycloudFXTrade", "EburyFXTrade"];
    FXTradeQuote: [
      "FXTradeFirmQuote",
      "FXTradeQuoteEstimate",
      "FXTradeSyntheticQuote",
    ];
    FileImportTransactionMatchedItem: [
      "FundUnitOrder",
      "LedgerEntry",
      "WestpacPaymentInstruction",
    ];
    FileImportTransactionOption: [
      "FileImportTransactionAnnotationOption",
      "FileImportTransactionFundUnitOrderOption",
      "FileImportTransactionNewDepositOption",
      "FileImportTransactionPayoutOption",
      "FileImportTransactionStripePayoutOption",
      "FileImportTransactionTransferNewOption",
      "FileImportTransactionTransferOption",
      "FileImportTransactionWestpacPaymentInstructionOption",
    ];
    FundMovement: [
      "Deposit",
      "EburyFXTrade",
      "FundUnitOrder",
      "Payout",
      "Transfer",
    ];
    ImportFile: [
      "MacquarieTransactionImportFile",
      "WestpacTransactionImportFile",
    ];
    LedgerAccount: [
      "AssetLedgerAccount",
      "BeneficiaryLedgerAccount",
      "CustodyLedgerAccount",
      "FXMarginProviderLedgerAccount",
      "OrganisationLedgerAccount",
    ];
    Node: [
      "AccountStatement",
      "ActivityStatement",
      "Address",
      "AlertAssetRule",
      "AssetLedgerAccount",
      "BalanceStatement",
      "BankAccountProduct",
      "BeneficiaryAccount",
      "BeneficiaryLedgerAccount",
      "BusinessEntity",
      "CalastoneOrder",
      "CurrencycloudFXTrade",
      "CustodyAccount",
      "CustodyLedgerAccount",
      "Deposit",
      "EburyAccount",
      "EburyBeneficiary",
      "EburyFXTrade",
      "Event",
      "ExternalBankAccountAsset",
      "ExternalBankStatement",
      "ExternalFXHedge",
      "FXAsset",
      "FXMarginProviderLedgerAccount",
      "FixedIncomeFundAsset",
      "FundProduct",
      "FundUnitOrder",
      "LedgerTransaction",
      "MacquarieTransactionImportFile",
      "ManagedFXHedge",
      "MonthlyStatement",
      "NoticeAccountAsset",
      "Organisation",
      "OrganisationLedgerAccount",
      "PaymentInstructionFile",
      "Payout",
      "RecurringTransferAssetRule",
      "RecurringWithdrawalAssetRule",
      "SavingsAsset",
      "ScheduledTransfer",
      "ScheduledWithdrawal",
      "StatementBatch",
      "SweepAssetRule",
      "TermDepositAsset",
      "TermDepositProduct",
      "TopUpAssetRule",
      "Transaction",
      "TransactionMonitoringEvaluation",
      "TransactionMonitoringFinding",
      "Transfer",
      "TransferGroup",
      "UnknownEventObject",
      "UsRIARecord",
      "UserProfile",
      "WestpacPaymentInstruction",
      "WestpacTransactionImportFile",
    ];
    PaymentIdentifier: [
      "AuBsbPaymentIdentifier",
      "AuPayIdPaymentIdentifier",
      "AuUnitFundPaymentIdentifier",
      "IbanPaymentIdentifier",
      "SwiftBicPaymentIdentifier",
      "SwiftPaymentIdentifier",
      "UsAbaPaymentIdentifier",
    ];
    Product: ["BankAccountProduct", "FundProduct", "TermDepositProduct"];
    ScheduledFundMovement: ["ScheduledTransfer", "ScheduledWithdrawal"];
    ScreeningEntity: ["BeneficiaryAccount", "BusinessEntity"];
    SettlementAccount: ["BeneficiaryAccount", "FXAsset", "SavingsAsset"];
    Statement: [
      "AccountStatement",
      "ActivityStatement",
      "BalanceStatement",
      "MonthlyStatement",
    ];
    TermDepositMaturityInstructions: [
      "TermDepositMaturityInstructionsRollover",
      "TermDepositMaturityInstructionsRolloverPrinciple",
      "TermDepositMaturityInstructionsTransfer",
    ];
    TimeLogUpdate: [
      "BaseTimeLogUpdate",
      "FXTradeTimeLogUpdate",
      "PayoutTimeLogUpdate",
    ];
    TransactionMonitoringEvaluationTarget: [
      "Deposit",
      "Organisation",
      "Payout",
      "Transfer",
    ];
    TransactionMonitoringFindingItemTarget: [
      "Deposit",
      "ExternalBankAccountAsset",
      "FXAsset",
      "FixedIncomeFundAsset",
      "NoticeAccountAsset",
      "Organisation",
      "Payout",
      "SavingsAsset",
      "TermDepositAsset",
      "Transfer",
    ];
    TransferUnit: ["TransferUnitCurrency", "TransferUnitFund"];
    UpcomingPolicyTransaction: ["Payout", "Transfer"];
    UserTask: [
      "AlertRuleUserTask",
      "ApprovalRequestUserTask",
      "ExternalAccountRelinkingUserTask",
      "FXFundingUserTask",
      "GroupedApprovalRequestUserTask",
      "GroupedExternalAccountRelinkingUserTask",
      "ManageAllocationsUserTask",
      "RuleWithdrawalReplacedUserTask",
    ];
  };
};
const result: PossibleTypesResultData = {
  possibleTypes: {
    Account: [
      "AirwallexExternalAccountDetails",
      "AkahuExternalAccountDetails",
      "BeneficiaryAccount",
      "BrexExternalAccountDetails",
      "ExternalBankAccountAsset",
      "FXAsset",
      "FixedIncomeFundAsset",
      "JpmcExternalAccountDetails",
      "MercuryExternalAccountDetails",
      "NoticeAccountAsset",
      "PlaidExternalAccountDetails",
      "QuilttExternalAccountDetails",
      "RampExternalAccountDetails",
      "SaltEdgeExternalAccountDetails",
      "SavingsAsset",
      "SissExternalAccountDetails",
      "SkriptExternalAccountDetails",
      "StripeExternalAccountDetails",
      "TermDepositAsset",
    ],
    AccountOnboardingRequest: [
      "FXOnboardingRequest",
      "ProductAccountOnboardingRequest",
    ],
    AccountsSummaryGroup: [
      "AccountTypeAccountsSummaryGroup",
      "AssetClassAccountsSummaryGroup",
      "BusinessEntityAccountsSummaryGroup",
      "CurrencyAccountsSummaryGroup",
      "ProviderAccountsSummaryGroup",
    ],
    ApprovalTarget: ["Payout", "Transfer", "TransferGroup"],
    Asset: [
      "ExternalBankAccountAsset",
      "FXAsset",
      "FixedIncomeFundAsset",
      "NoticeAccountAsset",
      "SavingsAsset",
      "TermDepositAsset",
    ],
    AssetRule: [
      "AlertAssetRule",
      "RecurringTransferAssetRule",
      "RecurringWithdrawalAssetRule",
      "SweepAssetRule",
      "TopUpAssetRule",
    ],
    BatchUpdateAssetResult: [
      "BatchUpdateAssetErrorResult",
      "BatchUpdateAssetSuccessResult",
    ],
    EburyTradeDetails: [
      "EburyDrawdownDetails",
      "EburyFixedForwardDetails",
      "EburyNDFDetails",
      "EburySpotTradeDetails",
      "EburyWindowForwardDetails",
    ],
    EventActor: [
      "EventActorExternalSystem",
      "EventActorExternalUser",
      "EventActorInternalUser",
      "EventActorScheduledJob",
      "EventActorStandaloneJob",
    ],
    ExternalAccountDetails: [
      "AirwallexExternalAccountDetails",
      "AkahuExternalAccountDetails",
      "BrexExternalAccountDetails",
      "JpmcExternalAccountDetails",
      "MercuryExternalAccountDetails",
      "PlaidExternalAccountDetails",
      "QuilttExternalAccountDetails",
      "RampExternalAccountDetails",
      "SaltEdgeExternalAccountDetails",
      "SissExternalAccountDetails",
      "SkriptExternalAccountDetails",
      "StripeExternalAccountDetails",
    ],
    ExternalBankAccountDataInstitution: [
      "AkahuExternalBankAccountDataInstitution",
      "BrexExternalBankAccountDataInstitution",
      "JpmcExternalBankAccountDataInstitution",
      "MercuryExternalBankAccountDataInstitution",
      "PlaidExternalBankAccountDataInstitution",
      "QuilttExternalBankAccountDataInstitution",
      "RampExternalBankAccountDataInstitution",
      "SaltEdgeExternalBankAccountDataInstitution",
      "SissExternalBankAccountDataInstitution",
      "SkriptExternalBankAccountDataInstitution",
      "StripeExternalBankAccountDataInstitution",
    ],
    FXHedge: ["ExternalFXHedge", "ManagedFXHedge"],
    FXProvider: ["CurrencycloudAccount", "EburyClient"],
    FXRateDataPoint: ["FXRateDataPointDate", "FXRateDataPointDateTime"],
    FXTrade: ["CurrencycloudFXTrade", "EburyFXTrade"],
    FXTradeQuote: [
      "FXTradeFirmQuote",
      "FXTradeQuoteEstimate",
      "FXTradeSyntheticQuote",
    ],
    FileImportTransactionMatchedItem: [
      "FundUnitOrder",
      "LedgerEntry",
      "WestpacPaymentInstruction",
    ],
    FileImportTransactionOption: [
      "FileImportTransactionAnnotationOption",
      "FileImportTransactionFundUnitOrderOption",
      "FileImportTransactionNewDepositOption",
      "FileImportTransactionPayoutOption",
      "FileImportTransactionStripePayoutOption",
      "FileImportTransactionTransferNewOption",
      "FileImportTransactionTransferOption",
      "FileImportTransactionWestpacPaymentInstructionOption",
    ],
    FundMovement: [
      "Deposit",
      "EburyFXTrade",
      "FundUnitOrder",
      "Payout",
      "Transfer",
    ],
    ImportFile: [
      "MacquarieTransactionImportFile",
      "WestpacTransactionImportFile",
    ],
    LedgerAccount: [
      "AssetLedgerAccount",
      "BeneficiaryLedgerAccount",
      "CustodyLedgerAccount",
      "FXMarginProviderLedgerAccount",
      "OrganisationLedgerAccount",
    ],
    Node: [
      "AccountStatement",
      "ActivityStatement",
      "Address",
      "AlertAssetRule",
      "AssetLedgerAccount",
      "BalanceStatement",
      "BankAccountProduct",
      "BeneficiaryAccount",
      "BeneficiaryLedgerAccount",
      "BusinessEntity",
      "CalastoneOrder",
      "CurrencycloudFXTrade",
      "CustodyAccount",
      "CustodyLedgerAccount",
      "Deposit",
      "EburyAccount",
      "EburyBeneficiary",
      "EburyFXTrade",
      "Event",
      "ExternalBankAccountAsset",
      "ExternalBankStatement",
      "ExternalFXHedge",
      "FXAsset",
      "FXMarginProviderLedgerAccount",
      "FixedIncomeFundAsset",
      "FundProduct",
      "FundUnitOrder",
      "LedgerTransaction",
      "MacquarieTransactionImportFile",
      "ManagedFXHedge",
      "MonthlyStatement",
      "NoticeAccountAsset",
      "Organisation",
      "OrganisationLedgerAccount",
      "PaymentInstructionFile",
      "Payout",
      "RecurringTransferAssetRule",
      "RecurringWithdrawalAssetRule",
      "SavingsAsset",
      "ScheduledTransfer",
      "ScheduledWithdrawal",
      "StatementBatch",
      "SweepAssetRule",
      "TermDepositAsset",
      "TermDepositProduct",
      "TopUpAssetRule",
      "Transaction",
      "TransactionMonitoringEvaluation",
      "TransactionMonitoringFinding",
      "Transfer",
      "TransferGroup",
      "UnknownEventObject",
      "UsRIARecord",
      "UserProfile",
      "WestpacPaymentInstruction",
      "WestpacTransactionImportFile",
    ],
    PaymentIdentifier: [
      "AuBsbPaymentIdentifier",
      "AuPayIdPaymentIdentifier",
      "AuUnitFundPaymentIdentifier",
      "IbanPaymentIdentifier",
      "SwiftBicPaymentIdentifier",
      "SwiftPaymentIdentifier",
      "UsAbaPaymentIdentifier",
    ],
    Product: ["BankAccountProduct", "FundProduct", "TermDepositProduct"],
    ScheduledFundMovement: ["ScheduledTransfer", "ScheduledWithdrawal"],
    ScreeningEntity: ["BeneficiaryAccount", "BusinessEntity"],
    SettlementAccount: ["BeneficiaryAccount", "FXAsset", "SavingsAsset"],
    Statement: [
      "AccountStatement",
      "ActivityStatement",
      "BalanceStatement",
      "MonthlyStatement",
    ],
    TermDepositMaturityInstructions: [
      "TermDepositMaturityInstructionsRollover",
      "TermDepositMaturityInstructionsRolloverPrinciple",
      "TermDepositMaturityInstructionsTransfer",
    ],
    TimeLogUpdate: [
      "BaseTimeLogUpdate",
      "FXTradeTimeLogUpdate",
      "PayoutTimeLogUpdate",
    ],
    TransactionMonitoringEvaluationTarget: [
      "Deposit",
      "Organisation",
      "Payout",
      "Transfer",
    ],
    TransactionMonitoringFindingItemTarget: [
      "Deposit",
      "ExternalBankAccountAsset",
      "FXAsset",
      "FixedIncomeFundAsset",
      "NoticeAccountAsset",
      "Organisation",
      "Payout",
      "SavingsAsset",
      "TermDepositAsset",
      "Transfer",
    ],
    TransferUnit: ["TransferUnitCurrency", "TransferUnitFund"],
    UpcomingPolicyTransaction: ["Payout", "Transfer"],
    UserTask: [
      "AlertRuleUserTask",
      "ApprovalRequestUserTask",
      "ExternalAccountRelinkingUserTask",
      "FXFundingUserTask",
      "GroupedApprovalRequestUserTask",
      "GroupedExternalAccountRelinkingUserTask",
      "ManageAllocationsUserTask",
      "RuleWithdrawalReplacedUserTask",
    ],
  },
};
export default result;
